import React from 'react';

function MediaBuyers() {
  return <></>;
}

export default MediaBuyers;
